import React, { FC } from 'react';
import { Controller, get, useFormContext } from 'react-hook-form';
import { ChassisSeriesTypes } from '../../../../@types/ChassisType';
import { Stack, Typography } from '@mui/material';
import CheckBox from '../FormFields/CheckBox/CheckBox';


interface ChassisSeriesTypeOptionsProps {
  name: string,
}

const ChassisSeriesTypeOptions: FC<ChassisSeriesTypeOptionsProps> = ({ name }) => {

  const { control, formState: { errors } } = useFormContext();

  const error = get(errors, name);

  const options = Object.values(ChassisSeriesTypes);

  const optionsFiltered = options.filter((option) => option !== 'ESeries');

  return (
    <>
      {optionsFiltered.map((option) => (
        <Controller
          key={option}
          name={name}
          control={control}
          render={({ field }) => {
            return (
              <Stack direction="row" alignItems="center">
                <CheckBox checked={field.value?.includes(option) ?? false}
                  onChange={() => {
                    let newValue = [];
                    if (field.value) {
                      newValue = field.value?.includes(option)
                        ? field.value.filter((value: any) => value !== option)
                        : [...field.value ?? [], option];
                    } else {
                      newValue = [option];
                    }
                    field.onChange(newValue);
                  }}>
                </CheckBox>
                {option === 'XSeries' &&
                  <img
                    onClick={() => {
                      let newValue = [];
                      if (field.value) {
                        newValue = field.value?.includes(option)
                          ? field.value.filter((value: any) => value !== option)
                          : [...field.value ?? [], option];
                      } else {
                        newValue = [option];
                      }
                      field.onChange(newValue);
                    }}
                    style={{ cursor: 'pointer' }}
                    src={`https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/561bdc4a-93b4-4ab4-a825-8f2f83155500/w=${180}`}
                    width="180px"
                    height="31px"
                    alt="MadJax XSeries Logo" />

                }
                {option === 'Ascent' &&
                  <img
                    onClick={() => {
                      let newValue = [];
                      if (field.value) {
                        newValue = field.value?.includes(option)
                          ? field.value.filter((value: any) => value !== option)
                          : [...field.value ?? [], option];
                      } else {
                        newValue = [option];
                      }
                      field.onChange(newValue);
                    }}
                    style={{ cursor: 'pointer' }}
                    src={`https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/47794e75-a6e8-4d3d-bd4a-8f93e062e500/w=${180}`}
                    width="180px"
                    height="31px"
                    alt="MadJax Ascent Logo" />

                }
              </Stack>
            )
          }} />
      ))}
      <Typography variant="errorFont">
        {String(error?.message ?? "")}
      </Typography>
    </>
  )


}


export default ChassisSeriesTypeOptions;
